<template>
  <!-- title -->
  <div class="mt-4 mb-8 h-10 w-[400px] max-w-full bg-neutral-50"></div>
  <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
    <!-- Banner -->
    <div class="relative h-[500px] w-full rounded-lg lg:w-[290px] lg:min-w-[290px] lg:flex-none bg-neutral-50"></div>

    <!-- Products -->
    <div class="w-full">
      <div
        :class="[
          'grid grid-cols-1 gap-6 xs:grid-cols-2 lg:gap-5',
          `md:grid-cols-${columnsAmountTablet}`,
          `lg:grid-cols-${columnsAmountDesktop}`,
        ]"
      >
        <div v-for=" in itemCount" class="flex flex-col w-full h-full bg-neutral-50 min-h-[240px] mt-6 lg:mt-0"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import { computed } from "vue";
interface IProps {
  columnsAmountDesktop?: string;
  columnsAmountTablet?: string;
}
defineProps<IProps>();
const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg");
const itemCount = computed(() => (isMobile.value ? 2 : 8));
</script>
